<template>
    <el-dialog
        :append-to-body="true"
        :modal-append-to-body="true"
        :visible.sync="dialogVisible"
        title="新增特别说明"
        width="60%"
        @close="handleClose">

        <!-- 头部导入模板按钮 -->
        <div class="header-actions">
            <el-button size="small" type="primary" @click="openTemplateDialog">
                导入模板
            </el-button>
        </div>

        <!-- 富文本编辑器 -->
        <div class="editor-container">
            <Ueditor ref="ueditor" :height="400" :parentId="0"/>
        </div>

        <!-- 底部操作区域 -->
        <div slot="footer" class="dialog-footer">
            <div class="left-actions">
                <el-checkbox v-model="saveToTemplate">
                    将该说明保存至公司模板库
                </el-checkbox>
            </div>
            <div class="right-actions">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </div>
        </div>

        <!-- 导入模板弹框 -->
        <import-template-dialog ref="importTemplateDialog"
                                :resourceId="resourceId"
                                @template-selected="handleTemplateSelected"/>
    </el-dialog>
</template>

<script>
import Ueditor from '@/components/Editor/Ueditor.vue'
import ImportTemplateDialog from './importTemplateDialog.vue'
import Api from '@/components/Api/index.js'

export default {
    name: 'AddSpecialNotePopup',
    components: {
        Ueditor,
        ImportTemplateDialog
    },
    data() {
        return {
            dialogVisible: false,
            saveToTemplate: false,
            currentContent: '',
            stockId: null,//库存id
            resourceId: null,

        }
    },
    methods: {
        // 打开弹框
        openDialog(resourceId, stockId) {
            this.resourceId = resourceId
            this.stockId = stockId
            this.dialogVisible = true
            // 调用获取酒店模版详情方法
            this.getHotelTemplateDetail()
            // this.saveToTemplate = false
            // this.currentContent = ''
            // 清空富文本内容
            this.$nextTick(() => {
                if (this.$refs.ueditor) {
                    this.$refs.ueditor.setUeContent('')
                }
            })
        },
        // 获取酒店模版详情
        getHotelTemplateDetail() {
            new Api('resource').getHotelTemplateDetail(this.stockId).then(res => {
                if (res.status === 200) {
                    this.$refs.ueditor.setUeContent(res.data || '')
                } else {
                    this.$message.error(res.statusText || '获取失败')
                }
            }).catch(() => {
                this.$message.error('服务器错误')
            })
        },
        // 关闭弹框
        handleClose() {
            this.dialogVisible = false
            this.saveToTemplate = false
            this.currentContent = ''
        },

        // 打开导入模板弹框
        openTemplateDialog() {
            this.$refs.importTemplateDialog.openDialog()
        },

        // 处理模板选择
        handleTemplateSelected(template) {
            if (this.$refs.ueditor && template.content) {
                this.$refs.ueditor.setUeContent(template.content)
            }
        },

        // 保存操作
        async handleSave() {
            try {
                // 获取富文本内容
                const content = await this.$refs.ueditor.getContent()

                if (!content || content.trim() === '') {
                    this.$message.warning('请输入特别说明内容')
                    return
                }

                // 构建保存数据
                const saveData = {
                    id: this.stockId,//库存id
                    specialNote: content,//富文本内容
                    specialNoteId: null,//模版id特别说明id
                    isSelf: Number(this.saveToTemplate),//1 是加入  0是不加入
                }

                console.log(saveData, '看看保存的数据')
                new Api('resource').addHotelTemplate(saveData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('保存成功')
                        this.handleClose()
                        // 触发父组件事件
                        this.$emit('save-success', saveData)
                    } else {
                        this.$message.error(res.statusText || '保存失败')
                    }
                }).catch(() => {
                    this.$message.error('服务器错误')
                })
            } catch (error) {
                console.error('保存失败:', error)
                this.$message.error('保存失败，请重试')
            }
        },

        // 保存特别说明的API调用（示例）
        async saveSpecialNote(data) {
            // 这里实现具体的API调用逻辑
            // return new Api('plan').saveSpecialNote(data)
        }
    }
}
</script>

<style lang="scss" scoped>
.header-actions {
    margin: 20px 0;
    text-align: right;
}

.editor-container {
    margin: 20px 0;
    min-height: 520px;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-actions {
        margin-right: 30px;
        flex: 1;
    }

    .right-actions {
        display: flex;
        gap: 10px;
    }
}

::v-deep .el-dialog__body {
    padding: 20px;
}

::v-deep .el-dialog__footer {
    padding: 10px 20px 20px;
}
</style>